import { inject, Injectable } from '@angular/core';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  CreateEmployee,
  EmployeerStatus,
  UpdateEmployee,
} from '../models/employee.model';
import { SelectOption } from '../../shared/models/dropdowm.model';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    fullName?: string,
    email?: string
  ) {
    let params = '';

    if (fullName) params += `&fullName=${fullName}`;
    if (email) params += `&email=${email}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/employees?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/employees/' + id
    );
  }

  create(data: CreateEmployee) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/employees',
      data
    );
  }

  update(id: string, data: UpdateEmployee) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/employees/' + id,
      data
    );
  }

  getEmployeerStatusOptions(): SelectOption[] {
    return [
      { label: 'Ativo', value: EmployeerStatus.Active },
      { label: 'Desativado', value: EmployeerStatus.Deactivated },
      { label: 'Bloqueado', value: EmployeerStatus.Locked },
    ];
  }
}
